



























import { SketchRelatedData } from '@tt4b/ttam-enums';
import { trackEvent } from '@tt4b/ttam-utils';
import { useAutoSaveSketchRelatedData } from '@tt4b/ttam-hooks';
import { computed, defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import statusPopover from './popover.vue';
import { i18n } from '@tt4b/ttam-i18n';
import { get } from 'lodash-es';

const name = 'ttam-auto-save-status';
export default defineComponent({
  name,
  components: { statusPopover },
  props: {
    visible: { type: Boolean, default: false },
    campaignSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    adgroupSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    creativeSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    isReachLimitPopoverAutoShow: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { campaignSketchRelatedData, adgroupSketchRelatedData, creativeSketchRelatedData } = toRefs(props);
    const autoSavePopoverRef = ref();

    const {
      isCampaignSketchReachLimitError,
      isAdgroupSketchReachLimitError,
      isCreativeSketchReachLimitError,
      isSketchSaved,
      isSketchSaving,
      isSketchSaveError,
      isSketchReachLimit,
      isSketchPublished,
      isSketchDeleted,
      isSketchPermissionError,
      lastAutoSaveTime,
      isHasDraftId,
    } = useAutoSaveSketchRelatedData({
      campaignSketchRelatedData,
      adgroupSketchRelatedData,
      creativeSketchRelatedData,
    });

    const saveInfoLabel = computed(() => {
      if (isSketchSaveError.value) {
        if (!isSketchReachLimit.value && !isSketchPublished.value && !isSketchDeleted.value && isHasDraftId.value) {
          if (lastAutoSaveTime.value && lastAutoSaveTime.value.day > 0) {
            return i18n.t('draft_auto_save_draft_saved_time_day_new', {
              num: lastAutoSaveTime.value.day,
            });
          } else if (lastAutoSaveTime.value && lastAutoSaveTime.value.hour > 0) {
            return i18n.t('draft_auto_save_draft_saved_time_hour_new', {
              num: lastAutoSaveTime.value.hour,
            });
          }
          return i18n.t('draft_auto_save_draft_saved_time_min_new', {
            num: get(lastAutoSaveTime, 'value.min', 1),
          });
        }
        return i18n.t('draft_auto_save_draft_no_saved');
      } else if (isSketchSaved.value) {
        return i18n.t('draft_auto_save_draft_saved');
      }
      return '';
    });

    const onShow = () => {
      if (isSketchDeleted.value) {
        return trackEvent('ttam_creation_draft_delete_tooltip');
      }
      if (isSketchPublished.value) {
        return trackEvent('ttam_creation_draft_published_tooltip');
      }
    };

    const handleRetry = (isCommonError: boolean) => {
      emit('retry', isCommonError);
    };

    const handleManageDraft = () => {
      emit('manage-draft');
    };

    const updatePopper = () => {
      autoSavePopoverRef.value.updatePopper();
    };

    return {
      name,
      autoSavePopoverRef,
      isSketchSaving,
      isSketchReachLimit,
      isSketchPermissionError,
      isCampaignSketchReachLimitError,
      isAdgroupSketchReachLimitError,
      isCreativeSketchReachLimitError,
      saveInfoLabel,
      onShow,
      handleRetry,
      handleManageDraft,
      updatePopper,
    };
  },
});
